import React from 'react'
import "../styles/Home.css"
import "../styles/ScrollGallery.css"
import { Link } from 'react-router-dom'
import ViralTikToks from '../components/ViralTikToks.js'
import ClientsSilder from '../components/clientsHome/ClientsSlider.js'

const Home = () => {
  return (
    <div className='minHeight100'>
      <div className='hero'>
        <div className='hero-text'>
          <h3>
            <span>Gift Bags</span>
            <span> by Rachael</span>
          </h3>
          <p>Giving the greatest brands world-class exposure.</p>
        </div>
        <div className='hero-images'>
          <img src="/home/hero/smiling-with-product.png" alt="hero" className='hero-image landscape' />
          <img src="/home/hero/superbowl-smiling.jpg" alt="hero" className='hero-image portrait-1' />
          <img src="/home/hero/otterbox-smiling.jpg" alt="hero" className='hero-image portrait-2' />
        </div>
      </div>

      <div className='clientEvents'>
        {/* <div className='logosBox'>
          {
            eventImages.map(imgName => <img key={imgName} src={`/home/eventLogos/${imgName}`} />)
          }
        </div> */}
        <h1 className='bold'>CLIENTS</h1>
        <p className='intro-text'>Gift Bags By Rachael is a trusted industry leader specializing in events, marketing, consulting, high profile brand and product placement, sponsorship opportunities, entertainment marketing, strategic partnerships, media exposure and more.</p>
        <div className='scroll-container'>
          <ClientsSilder/>
        </div>
        <div className='link'>
          <Link className='buttonlink' to="/events">Learn More →</Link>
        </div>
      </div>

      <div className='featured-events-section'>
        <div className='section-container'>
          <h2 className='section-title'>FEATURED EVENTS</h2>
          <p className='events-intro intro-text'>
            Featuring exclusive behind-the-scenes moments from our most prestigious celebrity gifting events and red carpet experiences.
          </p>
          <div className='events-grid'>
            <div className='event-card'>
              <div className='event-image-container'>
                <img src="/home/featuredEventsImages/grammys.webp" alt="GRAMMYs" className='event-image' />
                <div className='event-overlay-home'>
                  <h3 className='event-title-home'>GRAMMYs</h3>
                  <p className='event-description-home'>Music's biggest night featuring A-list talent</p>
                </div>
              </div>
            </div>
            <div className='event-card'>
              <div className='event-image-container'>
                <img src="/home/featuredEventsImages/dwts.jpg" alt="DWTS" className='event-image' />
                <div className='event-overlay-home'>
                  <h3 className='event-title-home'>DWTS</h3>
                  <p className='event-description-home'>Celebrity ballroom competition</p>
                </div>
              </div>
            </div>
            <div className='event-card'>
              <div className='event-image-container'>
                <img src="/home/featuredEventsImages/superbowl.jpg" alt="The Super Bowl" className='event-image' />
                <div className='event-overlay-home'>
                  <h3 className='event-title-home'>The Super Bowl</h3>
                  <p className='event-description-home'>One of the biggest sporting events in the USA</p>
                </div>
              </div>
            </div>
          </div>
          <div className='events-cta'>
            <Link className='btn-primary' to="/events">View All Events →</Link>
          </div>
        </div>
      </div>

      <div className='social-media-section'>
        <div className='section-container'>
          <div className='tiktok-header'>
            <div className='tiktok-info'>
              <h2 className='section-title'>SOCIAL MEDIA</h2>
              <div className='tiktok-description'>
                <p className='intro-text'>
                  Follow Gift Bags by Rachael on TikTok and Instagram for exclusive behind-the-scenes content, 
                  celebrity interactions, and the latest from Hollywood's most prestigious events.
                </p>
                <div className='social-buttons'>
                  <a rel="noopener noreferrer" className='btn-secondary' target="_blank" href='https://www.tiktok.com/@giftbagsbyrachael'>
                    Follow on TikTok →
                  </a>
                  <a rel="noopener noreferrer" className='btn-secondary' target="_blank" href='https://www.instagram.com/giftbagsbyrachael'>
                    Follow on Instagram →
                  </a>
                </div>
              </div>
            </div>
          </div>
          <ViralTikToks />
        </div>
      </div>

      {/* <div className='social-links-section'>
        <div className='section-container'>
          <h2 className='section-title'>CONNECT WITH US</h2>
          <div className='social-links-grid'>
            <a 
              href="https://www.tiktok.com/@giftbagsbyrachael" 
              target="_blank" 
              rel="noopener noreferrer"
              className='social-link'
            >
              <div className='social-icon'><FaTiktok /></div>
              <span>@GiftBagsByRachael</span>
              <small>TikTok</small>
            </a>
            <a 
              href="https://www.instagram.com/giftbagsbyrachael" 
              target="_blank" 
              rel="noopener noreferrer"
              className='social-link'
            >
              <div className='social-icon'><FaInstagram /></div>
              <span>@GiftBagsByRachael</span>
              <small>Instagram</small>
            </a>
            <a 
              href="https://www.linkedin.com/in/rachaelhonowitz/" 
              target="_blank" 
              rel="noopener noreferrer"
              className='social-link'
            >
              <div className='social-icon'><FaLinkedin /></div>
              <span>Rachael Honowitz</span>
              <small>LinkedIn</small>
            </a>
            <a 
              href="mailto:info@giftbagsbyrachael.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className='social-link'
            >
              <div className='social-icon'><MdEmail /></div>
              <span>info@giftbagsbyrachael.com</span>
              <small>Email</small>
            </a>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default Home